module.exports = __webpack_public_path__ + "img/pr-3.abd04b75.png";